module.exports = __webpack_public_path__ + "static/media/arrow_left.c2a1857d.svg";